import { useCallback } from "react";
import { styled } from "styled-components";
import IconButton from "../Button/IconButton";
import { CardViewIcon, ListViewIcon } from "../Svg";

export enum ViewMode {
  TABLE = "TABLE",
  CARD = "CARD",
}

interface ToggleViewProps {
  idPrefix: string;
  viewMode: ViewMode;
  onToggle: (mode: ViewMode) => void;
}

const Container = styled.div`
  background: ${({ theme }) => theme.colors.input};
  margin-left: -8px;
  border-radius: 12px;
  padding: 4px;
  display: flex;
  align-items: center;
  button {
    padding: 5px 16px;
    width: auto;
    &.active {
      background: ${({theme}) => theme.colors.primary};
    }
  }
  ${({ theme }) => theme.mediaQueries.sm} {
    margin-left: 0;
  }
`;

export const ToggleView: React.FunctionComponent<React.PropsWithChildren<ToggleViewProps>> = ({
  idPrefix,
  viewMode,
  onToggle,
}) => {
  const handleToggleCard = useCallback(() => {
    if (viewMode !== ViewMode.CARD) {
      onToggle(ViewMode.CARD);
    }
  }, [onToggle, viewMode]);

  const handleToggleTable = useCallback(() => {
    if (viewMode !== ViewMode.TABLE) {
      onToggle(ViewMode.TABLE);
    }
  }, [onToggle, viewMode]);

  return (
    <Container>
      <IconButton aria-label="Card view" variant="text" scale="sm" id={`${idPrefix}CardView`} className={viewMode === ViewMode.CARD ? "active" : ""} onClick={handleToggleCard}>
        <CardViewIcon color={viewMode === ViewMode.CARD ? "invertedContrast" : "textDisabled"} width={32} />
      </IconButton>
      <IconButton aria-label="Table view" variant="text" scale="sm" id={`${idPrefix}TableView`} className={viewMode === ViewMode.TABLE ? "active" : ""} onClick={handleToggleTable}>
        <ListViewIcon color={viewMode === ViewMode.TABLE ? "invertedContrast" : "textDisabled"} width={32} />
      </IconButton>
    </Container>
  );
};
